module.exports = __webpack_public_path__ + "static/creativityBulbs-963c089ebba6a1cc2b0d100a1e475b38.png";